import React from 'react';
import PropTypes from 'prop-types';

import { delayedToggleClassWhenItemsInViewport } from '../../../../utils/helpers/viewport';

import Svg from '../../../../common/components/Svg';

import styles from './product.scss';

import checkMarkSvg from '../../../../common/assets/icons/check-mark.svg';
import chevronSvg from '../../../../common/assets/icons/chevron-right.svg';

class Product extends React.Component {
  constructor(props) {
    super(props);
    this.$usps = [];
    this.$leftCta = null;
    this.$rightCta = null;

    if (typeof window !== 'undefined' && window.setInterval) {
      this.uspsInterval = window.setInterval(() => {
        window.requestAnimationFrame(
          delayedToggleClassWhenItemsInViewport(this.$usps, styles.visible, 100)
        );
      }, 100);
    }
  }

  render() {
    return (
      <div className={this.props.attension ? styles.centerProduct : styles.product}>
        <h3>{this.props.name}</h3>

        <div className={styles.price}>
          <span className={styles.priceText}>{this.props.price}:-</span> / mån
        </div>

        <a
          href="/Scandgate_Priser.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.cta}
        >
          Läs mer
          <Svg src={chevronSvg} className={styles.ctaChevron} />
        </a>

        <div className={styles.productContent}>
          <p>{this.props.tagline}</p>
        </div>

        <ul className={styles.uspList}>
          {this.props.usps.map(usp => (
            <li key={usp} ref={(c) => { this.$usps.push(c); }}>
              <Svg src={checkMarkSvg} className={styles.checkIcon} />
              <div className={styles.uspText}>{usp}</div>
            </li>
        ))}
        </ul>

        <ul className={styles.infoList}>
          {this.props.infoListItems.map(item => (
            <li key={`${item.item}-${item.description}`}>
              <div className={styles.infoListItem}>{item.item}</div>
              {item.description}
            </li>
        ))}
        </ul>
      </div>
    );
  }
}

const productPropTypes = {
  attension: PropTypes.bool,
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  tagline: PropTypes.string.isRequired,
  usps: PropTypes.arrayOf(PropTypes.string).isRequired,
  infoListItems: PropTypes.arrayOf(PropTypes.shape({
    item: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  })).isRequired,
};

Product.propTypes = productPropTypes;

Product.defaultProps = {
  attension: false,
};

export { productPropTypes };
export default Product;



// WEBPACK FOOTER //
// ./blocks/ProductsInfo/components/Product/index.js